<template>
    <div class="warpper padding-sm">
        <div class="page-title line-height">支付管理</div>
        <el-radio-group v-model="type" class="self-center margin-top">
            <el-radio-button :label="1">微信支付</el-radio-button>
            <el-radio-button :label="2">对公支付</el-radio-button>
        </el-radio-group>
        <div v-if="type === 1" class="page-info">
            <div class="basic-info active">
                <el-form ref="ruleForm" :model="ruleForm" :rules="rules"
                         class="flex flex-direction justify-center" label-width="auto">
                    <el-form-item label="公众平台(appid)" prop="wx_appid">
                        <el-input v-model="ruleForm.wx_appid" placeholder="请输入公众平台appid"></el-input>
                    </el-form-item>
                    <el-form-item label="公众平台(appsecret)" prop="wx_appsecret">
                        <el-input v-model="ruleForm.wx_appsecret" placeholder="请输入公众平台appsecret"></el-input>
                    </el-form-item>
                    <el-form-item label="商户平台商户号(mch_id)" prop="wx_mch_id">
                        <el-input v-model="ruleForm.wx_mch_id" placeholder="请输入商户平台商户号"></el-input>
                    </el-form-item>
                    <el-form-item label="商户平台密钥(appsecret)" prop="wx_apikey">
                        <el-input v-model="ruleForm.wx_apikey" placeholder="请输入商户平台密钥"></el-input>
                    </el-form-item>
                    <el-form-item label="是否开启H5支付" prop="is_h5">
                        <el-radio-group v-model="ruleForm.is_h5">
                            <el-radio :label="1">开启</el-radio>
                            <el-radio :label="0">关闭</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-button :loading="loading" class="input-form-btn" @click="submitForm('ruleForm')">保存配置
                    </el-button>
                </el-form>
            </div>
            <div class="tips"> 以上资料信息可登陆
                <el-link class="link" href="https://mp.weixin.qq.com/" target="_blank">
                    微信公众平台（服务号）
                </el-link>
                、
                <el-link class="link" href="https://pay.weixin.qq.com/index.php/core/home/login?return_url=%2Findex.php%2Fextend%2Fproduct%2Flists%3Ftid%3D3" target="_blank">
                    微信商户平台
                </el-link><br>
                申请或查看 <br>如有疑问，请拨打服务电话:{{ service_phone }}
            </div>
        </div>
        <div v-if="type === 2" class="page-info">
            <div class="basic-info active">
                <el-form ref="ruleForm" :model="ruleForm" :rules="rules"
                         class="flex flex-direction justify-center" label-width="auto">
                    <el-form-item label="开户行" prop="kaiHuHang">
                        <el-input v-model="ruleForm.kaiHuHang" placeholder="请输入开户行"></el-input>
                    </el-form-item>
                    <el-form-item label="收款单位" prop="shouKuanDanWei">
                        <el-input v-model="ruleForm.shouKuanDanWei" placeholder="请输入收款单位"></el-input>
                    </el-form-item>
                    <el-form-item label="银行卡号" prop="kaHao">
                        <el-input v-model="ruleForm.kaHao" placeholder="请输入卡号"></el-input>
                    </el-form-item>
                    <el-form-item ref="fapiao_img" label="发票票样"
                                  prop="fapiao_img">
                        <el-upload
                            :action="`${baseURL}/home/img/upload`"
                            :data="fileData"
                            :name="'file'"
                            :on-success="(res)=>{ return handleAvatarSuccess(res,'fapiao_img')}"
                            :show-file-list="false"
                            accept="image/*"
                            class="avatar-uploader">
                            <div class="flex align-center">
                                <el-image v-if="ruleForm.fapiao_img" :src="IMAGE_PATH + ruleForm.fapiao_img" class="logo"></el-image>
                                <div v-else class="logo up">点击上传</div>
                            </div>
                        </el-upload>
                    </el-form-item>
                    <el-form-item ref="pay_img" label="支付二维码"
                                  prop="pay_img">
                        <div class="flex align-center">
                            <el-upload
                                :action="`${baseURL}/home/img/upload`"
                                :data="fileData"
                                :name="'file'"
                                :on-success="(res)=>{ return handleAvatarSuccess(res,'pay_img')}"
                                :show-file-list="false"
                                accept="image/*"
                                class="avatar-uploader">
                                <div class="flex align-center">
                                    <el-image v-if="ruleForm.pay_img" :src="IMAGE_PATH + ruleForm.pay_img" class="logo"></el-image>
                                    <div v-else class="logo up">点击上传</div>
                                </div>
                            </el-upload>
                            <el-button class="margin-left-sm"  type="primary" round @click="ruleForm.pay_img = ''">清除
                            </el-button>
                        </div>
                    </el-form-item>
                    <el-button :loading="loading" class="input-form-btn" @click="submitForm('ruleForm')">保存配置
                    </el-button>
                </el-form>
            </div>
        </div>
    </div>
</template>

<script>
import {service_phone} from "@/utils/const";
import {getWxPayInfo, setWxPayInfo} from '@/api/organiz'
import {getDuiGongData, setDuiGongData} from "../../../../api/organiz";
import {baseURL, IMAGE_PATH} from "@/config";

export default {
    name: "pay",
    data() {
        return {
            IMAGE_PATH:IMAGE_PATH,
            baseURL: baseURL,
            service_phone: service_phone,
            type: 1,
            ruleForm: {
                wx_appid: '',
                wx_appsecret: '',
                wx_mch_id: '',
                wx_apikey: '',
                is_h5: 0,

                kaiHuHang: '',
                kaHao: '',
                shouKuanDanWei: '',
                fapiao_img: '',
                pay_img: '',
            },
            rules: {
                wx_appid: [
                    {required: true, message: "请输入公众平台appid", trigger: "blur"}
                ],
                wx_appsecret: [
                    {required: true, message: "请输入公众平台appsecret", trigger: "blur"}
                ],
                wx_mch_id: [
                    {required: true, message: '请输入商户平台商户号', trigger: 'blur'}
                ],
                wx_apikey: [
                    {required: true, message: '请输入商户平台密钥', trigger: 'blur'}
                ],

                // kaiHuHang: [
                //     {required: true, message: "请输入开户行", trigger: "blur"}
                // ],
                // shouKuanDanWei: [
                //     {required: true, message: '请输入收款单位', trigger: 'blur'}
                // ],
                // kaHao: [
                //     {required: true, message: '请输入卡号', trigger: 'blur'}
                // ]

            },
            loading: false
        }
    },
    computed: {
        user() {
            return this.$store.state.user
        },
        fileData() {
            return {
                uptype: 1,
                path: 'head'
            }
        }
    },
    created() {
        this.$emit('setIndex', [4, 2], '支付设置')
        this.init()
    },
    components: {},
    methods: {
        async init() {
            let _data = await getWxPayInfo()
            if (_data.status === 200) {
                this.ruleForm.wx_appid = _data.data.wx_appid
                this.ruleForm.wx_appsecret = _data.data.wx_appsecret
                this.ruleForm.is_h5 = _data.data.is_h5 || 0
                this.ruleForm.wx_mch_id = _data.data.wx_mch_id
                this.ruleForm.wx_apikey = _data.data.wx_apikey
            }
            _data = await getDuiGongData()
            if (_data.status === 200) {
                this.ruleForm.kaiHuHang = _data.data.kaihuhang
                this.ruleForm.kaHao = _data.data.kahao
                this.ruleForm.shouKuanDanWei = _data.data.shoukuandanwei
                this.ruleForm.fapiao_img = _data.data.fapiao_img
                this.ruleForm.pay_img = _data.data.pay_img
            }
        },
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    if (this.type === 1) {
                        this.setWxPayInfo()
                    } else {
                        this.setDuiGongData()
                    }
                }
            });
        },
        async setDuiGongData() {
            this.loading = true
            let _data = await setDuiGongData(this.ruleForm.kaiHuHang, this.ruleForm.kaHao, this.ruleForm.shouKuanDanWei,this.ruleForm.fapiao_img,this.ruleForm.pay_img)
            this.loading = false
            if (_data.status === 200) {
                this.$message.success('提交成功')
            }
        },
        async setWxPayInfo() {
            this.loading = true
            let _data = await setWxPayInfo(this.ruleForm.wx_appid, this.ruleForm.wx_mch_id, this.ruleForm.wx_apikey,this.ruleForm.wx_appsecret,this.ruleForm.is_h5)
            this.loading = false
            if (_data.status === 200) {
                this.$message.success('提交成功')
            }
        },
        handleAvatarSuccess(res,name) {
            if (res.code === 1) {
                this.ruleForm[name] =  res.path
            } else {
                this.$message.error(res.info)
            }
        },
    },
    filters: {},
    watch: {
      type(){
        this.$refs['ruleForm'].clearValidate();
      }
    },
}
</script>

<style lang="scss" scoped>
.warpper {
    padding: 20px 30px;
    background-color: #ffffff;
    border-radius: 10px;

    .page-info {
        display: flex;
        flex-direction: column;
        width: 719px;
        margin: 20px auto 0;

        .tips {
            font-size: 22px;
            font-weight: bold;
            text-align: center;
            margin: 30px 0;
            line-height: 36px;

            .link {
                display: inline;
                color: #ffb400;
                font-size: 26px;
                font-weight: bold;
                text-align: center;
                position: relative;
                top: -2px;
            }
        }

        .basic-info {
            display: flex;
            flex-direction: column;
            background-color: #ffffff;
            border-radius: 10px;
            padding: 40px 63px 20px 0px;

            &.active {
                border: solid 1px #e4e4e4;
                padding: 40px 63px 20px 30px;
            }

            .pay-money {
                font-size: 16px;
                color: #999999;
                text-align: center;
                margin: 20px 0;

                span {
                    font-size: 24px;
                    color: #ed4444;
                }
            }

            .el-select {
                width: 100%;
            }

            .input-form-btn {
                width: 200px;
                height: 40px;
                background-image: linear-gradient(37deg, #ffb400 0%, #fc7802 100%),
                linear-gradient(#0a2240, #0a2240);
                background-blend-mode: normal, normal;
                border-radius: 20px;
                font-size: 16px;
                color: #ffffff;
                margin: 30px auto 0;
            }
        }

    }

    .logo {
        width: 160px;
        height: 80px;
        border: 1px dotted #fc7802;
        &.up {
            border: 1px dotted #999999;
            line-height: 80px;
            text-align: center;
        }
    }

}
</style>
